(ns dre.pages.admin.help.db)

(def init-db
  {:mappings nil
   :loading? true})
